export default "__VITE_ASSET__BzmhCG7t__"